import React from "react";
import { useEffect, useState } from "react";
import "../../../assest/index.css";
import { useParams, useSearchParams } from "react-router-dom";
import Header from "../../../component/header/Header";
import Footer_menu from "../../../component/footer_menu";
import getFetchConfig from "../../../utils/getFetchConfig";
import appURLs from "../../../appURL";
import rentStyle from "../BabySitter_view/BabySitter.module.css";
import FeaturedImage from "../../../../src/assest/images/Room for rent 4.png";
import addFreeImage from "../../../../src/assest/images/addfreeimg.png";
import sidebanner from "../../../../src/assest/images/Group 1686553294.png";
import Banner from "../../../component/Banner/Banner";
import { Link } from "react-router-dom";
import { ColorRing } from "react-loader-spinner";
import Tooltip from "../../../component/tools-tip/Tooltip";
import { Range } from "react-range";
import { toast } from "react-toastify";
import FilterLocation from "../../../component/postAds/select-location/FilterLocation";
import LocationsDone from "../../../component/postAds/select-location/LocationsDone";

import SimpleImageSlider from "react-simple-image-slider";
import SocialMediaLink from "../../../component/socialMediaLink/socialMediaLink";

import moment from 'moment-timezone';
import 'moment-duration-format';

function BabySitter_view({ setOverrideLocation, clearOverrideLocation }) {
  const mySearch = useParams();
  const fetchConfig = getFetchConfig(),
    appURL = appURLs();
  const [searchParams] = useSearchParams();
  const [isFavourite, setIsFavourite] = useState(false);
  const [myId, setMyAdsId] = useState("")
  const [favStatus, setFavStatus] = useState([]);
  const { subCategory, category } = useParams();
  const [sortingOption, setSortingOption] = useState("Newest");
  const [isNotify, setIsNotify] = useState(() => {
    const storedValue = localStorage.getItem("babyify");
    return storedValue ? JSON.parse(storedValue) : false;
  });
  const [getNotify, setGetNotify] = useState(false);
  const [response, setResponse] = useState(null);
  const [babysitterData, setBabysitterData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPages, setPerPages] = useState();
  const [isPageShareOpen, setIsPageShareOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [url, seturl] = useState();
  const [isShareOpenlink, setIsShareOpenlink] = useState(false);
  const [shareID, setshareId] = useState("");
  // const [latitude, setLatitude] = useState(localStorage.getItem("latts") || null);
  // const [longitude, setLongitude] = useState(localStorage.getItem("langs") || null);
  const [latitude, setLatitude] = useState(searchParams.get("lat") || localStorage.getItem("latts") || null);
  const [longitude, setLongitude] = useState(searchParams.get("lng") || localStorage.getItem("langs") || null);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [featureStatus, setFeaturedStatus] = useState(false);
  // const geetingDataLTLNG = (lat, lang) => {
  //   // if(isChecked8){
  //   setLat(lang);
  //   setLang(lat);
  //   // }
  // };

  const locationChange = (lat, lang) => {
    setLongitude(lang);
    setLatitude(lat)
  };

  // Displaying data
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedWorkType, setSelectedWorkType] = useState(null);
  const [filterlocations, sefilterlectLocation] = useState();
  const [selectedCareService, setSelectedCareService] = useState(null);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState(null);
  const [selectedPrefferedLanguage, setSelectedPrefferedLanguage] = useState(null);
  const [selectedGender, setSelectedGender] = useState(null);
  const [addOnData, setaddOnData] = useState(["Urgent"]);
  const [FreePrice, setFreePrice] = useState(["Please Contact"]);
  const [selectedFree, setSelectedFree] = useState("");

  // Fetching data
  const [categoryData, setCategoryData] = useState([]);
  const [workType, setWorkType] = useState([]);
  const [careServices, setCareServices] = useState([]);
  const [ageGroup, setAgeGroup] = useState([]);
  const [languageType, setLanguageType] = useState([]);
  const [genderType, setGenderType] = useState(["Male", "Female"]);
  const [filterLetter, setFilterLetter] = useState("");
  const [addOn, setAddOn] = useState("");
  const [priceRange, setPriceRange] = useState([]);

  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [isChecked4, setIsChecked4] = useState(false);
  const [isChecked5, setIsChecked5] = useState(false);
  const [isChecked6, setIsChecked6] = useState(false);
  const [isChecked7, setIsChecked7] = useState(false);
  const [isChecked8, setIsChecked8] = useState(false);
  const check_fav = localStorage.getItem('babysitter_isFavorite');
const isFavView = searchParams.get("favorites") === "true";
  const hoveredCategory = localStorage.getItem("hoveredCategory");
  const selectedSubCategory = localStorage.getItem("selectedSubCategory");

  useEffect(() => {
    const urlLat = searchParams.get("lat");
    const urlLng = searchParams.get("lng");

    if (urlLat && urlLng) {
      setLatitude(urlLat);
      setLongitude(urlLng);
      // Reverse geocode to get city name
      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${urlLat}&lon=${urlLng}&format=json`)
        .then(res => res.json())
        .then(data => {
          const city = data.address?.city
            || data.address?.county
            || data.address?.state_district
            || data.address?.state
            || "Selected Location";

          // Send to App -> Header
          setOverrideLocation?.({ name: city, lat: urlLat, lng: urlLng });
        })
        .catch(() => {
          setOverrideLocation?.({ name: "Selected Location", lat: urlLat, lng: urlLng });
        });
    } else {
      // No URL params - clear override so Header shows normal location
      clearOverrideLocation?.();
    }
    // Cleanup when leaving this page
    return () => {
      clearOverrideLocation?.();
    };
  }, [searchParams]);

  useEffect(() => {
    const urlLat = searchParams.get("lat");
    const urlLng = searchParams.get("lng");
    if (urlLat && urlLng) {
      setLatitude(urlLat);
      setLongitude(urlLng);
    }
  }, [searchParams]);

  const fetchJobsData = async (currentPage, sortBy) => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };
      let apiUrl = `${appURL}/posts/babysitter/fetchAds?page=${currentPage}&sortBy=${sortBy || ""}`;
      if (hoveredCategory) {
        apiUrl += `&category=${hoveredCategory}`
      }
      // if (selectedSubCategory) {
      //   apiUrl += `sub_category=${selectedSubCategory}`
      // }
      const urlCategory = searchParams.get("category");
      const urlSubCategory = searchParams.get("sub_category");
      const categoryToUse = urlCategory || hoveredCategory;
      const subCategoryToUse = urlSubCategory || selectedSubCategory;
      if (categoryToUse) {
        apiUrl += `&category=${categoryToUse}`;
      }

      if (subCategoryToUse) {
        apiUrl += `&sub_category=${subCategoryToUse}`;
      }

      // if(selectedSubCategory && !check_fav && !mySearch.search) {
      //   apiUrl += `?category=${selectedSubCategory?.sub_category_name}&sortBy=${sortBy}`;
      // }

      if (latitude !== null && longitude !== null) {
        apiUrl += `&longitude=${longitude}&latitude=${latitude}&maxDistance=100`;
      }

      // if(mySearch.search){
      //   apiUrl+= `&search_term=${mySearch.search}`
      // }

      // if(check_fav){
      //   apiUrl += `&is_favorite=true`
      // }
      if(isFavView){
  apiUrl += `&is_favorite=true`
}

      // if (selectedCategory) {
      //   apiUrl += `&category=${selectedCategory}`;
      // }
      if (selectedWorkType) {
        apiUrl += `&work_type=${selectedWorkType}`;
      }

      if (selectedCareService) {
        apiUrl += `&care_service=${selectedCareService}`;
      }

      if (selectedAgeGroup) {
        apiUrl += `&age_group=${selectedAgeGroup}`;
      }

      if (selectedPrefferedLanguage) {
        apiUrl += `&prefered_language=${selectedPrefferedLanguage}`;
      }

      if (selectedGender) {
        apiUrl += `&prefered_gender=${selectedGender}`;
      }
      if (addOn) {
        apiUrl += `&add_on=${addOn}`;
      }

      // if (priceRange !== 0) {
      //   apiUrl += `&amount=${priceRange}`;
      // }

      if (priceRange > 0) {
        apiUrl += `&amount=${priceRange}`;
      }

      if (selectedFree === "Please Contact") {
        apiUrl += `&is_contact=${true}`;
      }

      const response = await fetch(apiUrl, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      const featuredData = jsonData.AdOnsData.featuredData || [];

      const mergedData = [
        ...featuredData,
        // ...jsonData.AdOnsData.bumpupData,
        ...jsonData.records,
      ];

      const roomRentDataWithCleanedDescriptions = mergedData.map(
        (record) => ({
          ...record,
          adsInfo: {
            ...record.adsInfo,
            descriptions: record.adsInfo.descriptions.replace(/<[^>]+>/g, ""), // Remove HTML tags
          },
        })
      );

      const featuredStatus = featuredData.map((record) => {
        const isFeatured =
          record.addons_validity &&
          record.addons_validity.some(
            (addon) => addon.name === "Featured"
          );

        return isFeatured;
      });
      setFeaturedStatus(featuredStatus)
      // setData(jsonData);
      setBabysitterData(roomRentDataWithCleanedDescriptions);
      setTotalPages(jsonData.totalPages);
      setTotal(jsonData.total);
      setPerPages(jsonData.perPage);
      setGetNotify(jsonData.notification);
      const favourite = mergedData.map((record) => record.is_favorite);
      setFavStatus(favourite);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setSelectedWorkType("")
  };
  const handleCheckboxChange2 = () => {
    setIsChecked2(!isChecked2);
    setPriceRange([]);
    setSelectedFree("")
  };
  const handleCheckboxChange3 = () => {
    setIsChecked3(!isChecked3);
    setSelectedAgeGroup("")
  };
  const handleCheckboxChange4 = () => {
    setIsChecked4(!isChecked4);
  };
  const handleCheckboxChange5 = () => {
    setIsChecked5(!isChecked5);
    setSelectedGender("")
  };
  const handleCheckboxChange6 = () => {
    setIsChecked6(!isChecked6);
    setAddOn("")
  };
  const handleCheckboxChange7 = () => {
    setIsChecked7(!isChecked7);
    setSelectedCategory("")
  };
  const handleCheckboxChange8 = () => {
    setIsChecked8(!isChecked8);
    if (!isChecked) {
      setLongitude(localStorage.getItem("langs"));
      setLatitude(localStorage.getItem("latts"));
    }
  };

  const clearAllFilters = () => {
    setSelectedCategory("");
    setSelectedWorkType("");
    setSelectedCareService("");
    setSelectedAgeGroup("");
    setSelectedPrefferedLanguage("");
    setSelectedGender("");
    setAddOn("");
    setPriceRange([]);
    setSelectedFree("");

    setIsChecked(false);
    setIsChecked2(false);
    setIsChecked3(false);
    setIsChecked4(false);
    setIsChecked5(false);
    setIsChecked6(false);
    setIsChecked7(false);
    setIsChecked8(false);

    fetchJobsData();
  };

  const handleRentRadioChange = (e) => {
    const value = e.target.value;
    setSelectedFree(value);
    setPriceRange("");
  };

  const handlebabyRadioChange = (e) => {
    const value = e.target.value;
    setSelectedCategory(value);
  };

  const handlePriceChange = (newValues) => {
    setPriceRange(newValues[0]);
    setSelectedFree("");
  };

  const filterDataByLetter = () => {
    if (filterLetter === "") {
      return babysitterData;
    }

    return babysitterData.filter((baby) =>
      baby.adsInfo.title.startsWith(filterLetter)
    );
  };

  const filteredData = filterDataByLetter();

  //  Dyamic data fetching

  const dynamicId = localStorage.getItem("dynamicId") || '64e48f6af9eeb14b6e2135b6';

  const fetchDynamicsData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };
      const response = await fetch(`${appURL}/posts/babysitter/dynamics-data?PostType=${dynamicId}`, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      setCategoryData(jsonData.data.category);
      // setWorkType(jsonData.data.work_type);
      // setCareServices(jsonData.data.care_service_need);
      // setAgeGroup(jsonData.data.age_group_need);
      // setLanguageType(jsonData.data.preferrd_languge_need);
      // setGenderType(jsonData.data.preferrd_gender_need);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Dynamic data Fetched


  const currentDate = new Date().toISOString().split('T')[0];

  const currentDates = new Date();
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // Use 24-hour format
  };

  const localTimeString = currentDates.toLocaleString('en-US', options);
  const formattedDateTime = `${currentDates.getFullYear()}-${(currentDates.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${currentDates.getDate().toString().padStart(2, '0')} ${currentDates
      .getHours()
      .toString()
      .padStart(2, '0')}:${currentDates.getMinutes().toString().padStart(2, '0')}:${currentDates
        .getSeconds()
        .toString()
        .padStart(2, '0')}`;
  // Get the timezone
  // Format the local time


  // Get the timezone


  const getTimeSinceCreation = (dateString, mytimers) => {

    // let dateString = rentDetailsData.ads_details.active_on_virtual;

    // Split the string at "T" and concatenate the date and time parts
    let parts = dateString.split("T");
    let extractedDate = parts[0] + "T" + parts[1].split(".")[0];

    const convertToTimeZone = (datetime, fromTimeZone, toTimeZone) => {
      return moment.tz(datetime, fromTimeZone).tz(toTimeZone).format('YYYY-MM-DD HH:mm:ss');
    };

    const originalDatetime = extractedDate;
    // const originalTimeZone = rentDetailsData.ads_details.location_timezone;

    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const targetTimeZone = timezoneString;

    const convertedDatetime = convertToTimeZone(originalDatetime, mytimers, targetTimeZone);
    if (formattedDateTime && convertedDatetime) {
      const secondsDiff = moment.duration(moment(formattedDateTime).diff(convertedDatetime)).asSeconds();


      if (secondsDiff < 60) {
        return "just now";
      } else if (secondsDiff < 3600) {
        const minutesDiff = Math.floor(secondsDiff / 60);
        return minutesDiff === 1 ? "1 minute ago" : `${minutesDiff} minutes ago`;
      } else if (secondsDiff < 86400) {
        const hoursDiff = Math.floor(secondsDiff / 3600);
        return hoursDiff === 1 ? "1 hour ago" : `${hoursDiff} hours ago`;
      } else if (secondsDiff < 172800) {
        return "Yesterday";
      } else {
        const daysDiff = Math.floor(secondsDiff / 86400);
        return daysDiff === 1 ? "1 day ago" : `${daysDiff} days ago`;
      }
    }
  }


  useEffect(() => {
    fetchJobsData(currentPage, subCategory, category);
  }, [
    currentPage,
    subCategory,
    category,
    selectedCategory,
    selectedWorkType,
    selectedCareService,
    selectedAgeGroup,
    selectedPrefferedLanguage,
    selectedGender,
    addOn,
    priceRange,
    selectedFree,
    latitude,
    longitude,
    mySearch

  ]);

  useEffect(() => {
    fetchDynamicsData();
  }, []);

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    window.scrollTo(0, window.innerHeight * 0.6);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    window.scrollTo(0, window.innerHeight * 0.6);
  };

  if (!babysitterData) {
    return (
      <div className={rentStyle.myLoader}>
        <ColorRing
          visible={true}
          height="80"
          width="80"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          colors={["#F17D3A", "#F17D3A", "#F17D3A", "#F17D3A", "#F17D3A"]}
        />
      </div>
    );
  }

  const handleApiRequest = async () => {
    try {
      const adsInfo = localStorage.getItem("adsInfo");
      const adsData = JSON.parse(adsInfo);

      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const apiUrl = `${appURL}/posts/ads/create-alert`;

      const requestOptions = {
        method: "POST",

        headers: headers,

        body: JSON.stringify({
          notification_status: !getNotify,
          ads_type: "64e48f6af9eeb14b6e2135b6",
        }),
      };

      const apiResponse = await fetch(apiUrl, requestOptions);

      if (apiResponse.ok) {
        const responseData = await apiResponse.json();
        setResponse(responseData);
        // toast.success(responseData.message);
      } else {
        console.error("API request failed:", apiResponse.statusText);
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  // const handleToggleChange = () => {
  //   setIsNotify(!isNotify);
  //   handleApiRequest();
  // };

  const handleToggleChange = () => {

    const updatedNotifyState = !getNotify;
    setGetNotify(updatedNotifyState);
    handleApiRequest(updatedNotifyState);
    const toastMessage = !getNotify
      ? "New Ads alert is turned on"
      : "New Ads alert is turned off";
    toast.success(toastMessage);

  };



  const buttonHnadler = (id) => {
    // navigate(`/rentDetails/${id}`);
  };

  const shareSocialMediaLink = (event, id, data) => {
    event.preventDefault();
    event.stopPropagation();
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/babySitterDetails/${id}`
    setshareId(id);
    seturl(url)
    setIsShareOpen(!isShareOpen);
  }

  //    const shareSocial = (event) => {
  //   event.preventDefault();
  //   event.stopPropagation();
  //     const baseUrl = window.location.origin;
  //   // let url = `${baseUrl}/view_for_Babysitter_and_nannies`
  //   let url = `${baseUrl}/view_for_Babysitter_and_nannies?lat=${latitude || ''}&lng=${longitude || ''}`;
  //   seturl(url);
  //   setIsPageShareOpen((prev) => !prev);
  // }
  const shareSocial = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/view_for_Babysitter_and_nannies?lat=${latitude || ''}&lng=${longitude || ''}`;

    // Get category and subcategory from various possible sources
    const categoryToShare = hoveredCategory || searchParams.get("category");
    const subCategoryToShare = selectedSubCategory || searchParams.get("sub_category");
    // Add category parameter if it exists
    if (categoryToShare) {
      url += `&category=${categoryToShare}`;
    }

    // Add subcategory parameter if it exists
    if (subCategoryToShare) {
      url += `&sub_category=${subCategoryToShare}`;
    }

    // Add any active filters
    if (selectedWorkType) url += `&work_type=${selectedWorkType}`;
    if (selectedCareService) url += `&care_service=${selectedCareService}`;
    if (selectedAgeGroup) url += `&age_group=${selectedAgeGroup}`;
    if (selectedPrefferedLanguage) url += `&prefered_language=${selectedPrefferedLanguage}`;
    if (selectedGender) url += `&prefered_gender=${selectedGender}`;
    if (addOn) url += `&add_on=${addOn}`;
    if (priceRange > 0) url += `&amount=${priceRange}`;
    if (selectedFree === "Please Contact") url += `&is_contact=true`;
    seturl(url);
    setIsPageShareOpen((prev) => !prev);
  }


  const sharelink = (id) => {
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/babySitterDetails/${id}`;
    seturl(url);

    setIsShareOpenlink(!isShareOpenlink);
  };



  const tokenExist = localStorage.getItem("token");

  const handleHeartIconClick = (index, _id) => {
    const adsInfo = localStorage.getItem("adsInfo");
    const adsData = JSON.parse(adsInfo);

    const currentStatus = favStatus[index];

    const requestBody = {
      adId: _id,
      ads_type: "64e48f6af9eeb14b6e2135b6",
      isfavorite: !currentStatus,
    };

    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    fetch(`${appURL}/posts/ads/create-favorite`, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: headers,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Response not OK");
        }
      })
      .then((data) => {
        setFavStatus((prevFavStatus) => ({
          ...prevFavStatus,
          [index]: !currentStatus,
        }));

        if (!currentStatus) {
          toast.success("Item added to Favorite");
        } else {
          toast.error("Item removed from Favorite");
        }
        // fetchJobsData();
      })
      .catch((error) => {
        console.error("Error sending the report:", error);
      });
  };


  const categoryName = localStorage.getItem("categoryName")
  const subcategoryName = localStorage.getItem("subcategoryName")

  return (
    <div>
      {/* <Header getCoordinates={geetingDataLTLNG} /> */}
      {/* <Header getCoordinates={geetingDataLTLNG} 
         loctiondata ={sefilterlectLocation}
         filterlocations={filterlocations}
      /> */}

      {/* Work starts from here */}
      <div className={rentStyle.main_wrapper}>
        <div className={rentStyle.banner_image}>
          {/* <img src={addFreeImage} alt="" /> */}
        </div>
        <h2 className={rentStyle.job_text}>Babysitter & Nannies</h2>
        {/* <div className="d-flex align-items-center" style={{ gap: '410px' }} > */}
        <div className={`d-flex align-items-center ${rentStyle.breadcrumb_share_row}`}>
          {/* <ul className={rentStyle.bradcrumb_bar}>
            <li>Home</li> */}
            {/* <li>
              {" "}
              <i className="fa-solid fa-angles-right"></i>
              {categoryName}
              {" "}
              <i className="fa-solid fa-angles-right"></i>
              {subcategoryName}
            </li> */}
            {/* <li>
              <i className="fa-solid fa-angles-right"></i>
              {(() => {
                const urlCategory = searchParams.get("category");
                if (urlCategory) {
                  const cat = categoryData?.find(c => c._id === urlCategory);
                  if (cat) return cat.name;
                }
                return categoryName ? categoryName : 'Babysitter & Nannies';
              })()}
              <i className="fa-solid fa-angles-right"></i>
              {(() => {
                const urlSubCategory = searchParams.get("sub_category");
                if (urlSubCategory) {
                  for (const cat of categoryData) {
                    const sub = cat?.subcategory?.find(s => s._id === urlSubCategory);
                    if (sub) return sub.name;
                  }
                }
                return subcategoryName;
              })()}
            </li> */}
            {/* {selectedSubCategory
                ? selectedSubCategory.sub_category_name
                : "Babysitter & Nannies"} */}
          {/* </ul> */}
          <ul className={rentStyle.bradcrumb_bar}>
  <li>Home</li>

  {/* Always show "Babysitter & Nannies" as second breadcrumb */}
  <li>
    <i className="fa-solid fa-angles-right"></i>
    Babysitter & Nannies
  </li>

  {(() => {
    const urlCategory = searchParams.get("category");
    const urlSubCategory = searchParams.get("sub_category");

    let resolvedName = null;

    // 1. Priority: subcategory from URL
    if (urlSubCategory) {
      for (const cat of categoryData || []) {
        const sub = cat?.subcategory?.find(s => s._id === urlSubCategory);
        if (sub?.name) {
          resolvedName = sub.name;
          break;
        }
      }
    }

    // 2. Fallback: category from URL
    if (!resolvedName && urlCategory) {
      const cat = categoryData?.find(c => c._id === urlCategory);
      if (cat?.name) resolvedName = cat.name;
    }

    // 3. Fallback: localStorage
    if (!resolvedName) {
      resolvedName = subcategoryName || categoryName;
    }

    // 4. If "View All" or nothing → show View All
    if (!resolvedName || resolvedName === "View All Babysitter & Nannies") {
      return (
        <li>
          <i className="fa-solid fa-angles-right"></i>
          View All Babysitter & Nannies
        </li>
      );
    }

    return (
      <li>
        <i className="fa-solid fa-angles-right"></i>
        {resolvedName}
      </li>
    );
  })()}
</ul>
          <div className="social"
            onClick={(event) => {
              shareSocial(event);
            }}
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={shareSocial}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.9997 20.4896C17.7312 20.4988 17.4637 20.4539 17.213 20.3575C16.9622 20.2611 16.7335 20.1152 16.5403 19.9285C16.3472 19.7419 16.1936 19.5182 16.0886 19.271C15.9837 19.0237 15.9297 18.7578 15.9297 18.4892C15.9297 18.2206 15.9837 17.9547 16.0886 17.7075C16.1936 17.4602 16.3472 17.2365 16.5403 17.0499C16.7335 16.8632 16.9622 16.7174 17.213 16.621C17.4637 16.5246 17.7312 16.4796 17.9997 16.4888C18.5184 16.5066 19.0099 16.7251 19.3705 17.0983C19.7312 17.4715 19.9328 17.9702 19.9328 18.4892C19.9328 19.0082 19.7312 19.5069 19.3705 19.8801C19.0099 20.2533 18.5184 20.4718 17.9997 20.4896ZM5.9997 14.4896C5.73125 14.4988 5.46369 14.4539 5.21296 14.3575C4.96224 14.2611 4.73349 14.1152 4.54032 13.9285C4.34716 13.7419 4.19355 13.5182 4.08864 13.271C3.98373 13.0237 3.92966 12.7578 3.92966 12.4892C3.92966 12.2206 3.98373 11.9547 4.08864 11.7075C4.19355 11.4602 4.34716 11.2365 4.54032 11.0499C4.73349 10.8632 4.96224 10.7174 5.21296 10.621C5.46369 10.5246 5.73125 10.4796 5.9997 10.4888C6.51839 10.5066 7.0099 10.7251 7.37055 11.0983C7.7312 11.4715 7.93278 11.9702 7.93278 12.4892C7.93278 13.0082 7.7312 13.5069 7.37055 13.8801C7.0099 14.2533 6.51839 14.4718 5.9997 14.4896ZM17.9997 4.49116C18.2682 4.48197 18.5357 4.52691 18.7864 4.6233C19.0372 4.7197 19.2659 4.86557 19.4591 5.05223C19.6522 5.23889 19.8059 5.46252 19.9108 5.7098C20.0157 5.95708 20.0697 6.22294 20.0697 6.49155C20.0697 6.76017 20.0157 7.02603 19.9108 7.27331C19.8059 7.52059 19.6522 7.74422 19.4591 7.93088C19.2659 8.11754 19.0372 8.26341 18.7864 8.35981C18.5357 8.4562 18.2682 8.50114 17.9997 8.49194C17.481 8.47419 16.9895 8.25566 16.6289 7.88245C16.2682 7.50924 16.0666 7.01054 16.0666 6.49155C16.0666 5.97256 16.2682 5.47387 16.6289 5.10066C16.9895 4.72745 17.481 4.50892 17.9997 4.49116ZM17.9997 14.4896C16.7716 14.4896 15.6864 15.0544 14.9528 15.9263L9.94423 13.0365C9.96767 12.856 10.0005 12.6779 10.0005 12.4904C10.0005 12.3779 9.97705 12.2724 9.96767 12.1623L15.0817 9.20913C15.453 9.61313 15.904 9.93582 16.4062 10.1569C16.9084 10.3779 17.451 10.4925 17.9997 10.4935C18.7909 10.4935 19.5643 10.2589 20.2222 9.81942C20.88 9.37991 21.3928 8.75521 21.6957 8.0243C21.9986 7.29339 22.078 6.48909 21.9238 5.71307C21.7696 4.93706 21.3888 4.22419 20.8295 3.66458C20.2702 3.10496 19.5576 2.72374 18.7817 2.56911C18.0057 2.41447 17.2014 2.49336 16.4703 2.79581C15.7392 3.09826 15.1142 3.61069 14.6743 4.26831C14.2344 4.92592 13.9994 5.6992 13.9989 6.49038C13.9989 6.8232 14.0528 7.14195 14.1278 7.45132L9.30439 10.2404C8.91608 9.67032 8.38698 9.21034 7.76845 8.90508C7.14993 8.59982 6.46299 8.45966 5.77431 8.4982C5.08564 8.53673 4.41862 8.75267 3.83802 9.12503C3.25741 9.49739 2.78294 10.0135 2.46066 10.6234C2.13837 11.2332 1.97922 11.916 1.99866 12.6055C2.0181 13.2949 2.21546 13.9677 2.57159 14.5584C2.92771 15.1491 3.43051 15.6377 4.03117 15.9768C4.63183 16.3158 5.30995 16.4938 5.9997 16.4935C7.30048 16.4912 8.44189 15.8607 9.17314 14.8998L14.0763 17.731C13.9194 18.5401 14.0161 19.3778 14.3533 20.1298C14.6906 20.8818 15.2518 21.5112 15.9603 21.9322C16.6688 22.3532 17.49 22.5451 18.3117 22.4816C19.1334 22.4182 19.9154 22.1026 20.5509 21.578C21.1865 21.0533 21.6445 20.3452 21.8623 19.5504C22.0802 18.7555 22.0473 17.9129 21.7681 17.1375C21.4889 16.3621 20.9771 15.6918 20.3026 15.2183C19.6281 14.7448 18.8238 14.4911 17.9997 14.4919V14.4896Z"
                fill="#6D737A"
              />
            </svg>
            {isPageShareOpen &&
              <SocialMediaLink url={url} />
            }

          </div>
        </div>

        <div className={rentStyle.clear_Filters}>
          <p onClick={clearAllFilters}>Clear All</p>
        </div>
        <div className={rentStyle.room_rent_details}>
          <div className={rentStyle.flters_lists_section}>
            <div className={rentStyle.accordion}>
              <div className="accordion">
                <div className="filter-wrapper">
                  <h2>Filters</h2>
                </div>

                <div className="accordion-item">
                  <input
                    id="accordion-trigger-6"
                    className="accordion-trigger-input"
                    type="checkbox"
                    checked={isChecked7}
                    onChange={handleCheckboxChange7}
                  ></input>
                  <label
                    className="accordion-trigger"
                    htmlFor="accordion-trigger-6"
                  >
                    Category
                  </label>
                  <section className="accordion-animation-wrapper">
                    <div className="accordion-animation">
                      <div className="accordion-transform-wrapper">
                        <div className="accordion-content">
                          <div className={rentStyle.input_box}>
                            {categoryData.map((item, index) => (
                              <label
                                key={index}
                                style={{ display: "flex", marginTop: "20px" }}
                              >
                                <input
                                  style={{ width: "40px", marginTop: "1px" }}
                                  type="radio"
                                  value={item?._id}
                                  checked={selectedCategory === item?._id}
                                  onChange={handlebabyRadioChange}
                                />
                                {item?.name}
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                <div className="accordion-item">
                  <input
                    id="accordion-trigger-1"
                    className="accordion-trigger-input"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  ></input>
                  <label
                    className="accordion-trigger accordion_change"
                    htmlFor="accordion-trigger-1"
                  >
                    Work Type
                  </label>
                  {/* workType */}
                  <section className="accordion-animation-wrapper">
                    <div className="accordion-animation">
                      <div className="accordion-transform-wrapper">
                        <div className="accordion-content">
                          {/* <label>Work Type:</label> */}

                          <select
                            value={selectedWorkType || ""}
                            onChange={(e) => {
                              const selectedValue = e.target.value;


                              setSelectedWorkType(selectedValue);
                            }}
                          >
                            {/* careServices  */}
                            <option value="">Select</option>
                            {workType.map((work) => (
                              <option key={work} value={work}>
                                {work}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                <div className="accordion-item">
                  <input
                    id="accordion-trigger-7"
                    className="accordion-trigger-input"
                    type="checkbox"
                    checked={isChecked8}
                    onChange={handleCheckboxChange8}
                  ></input>
                  <label
                    className="accordion-trigger"
                    htmlFor="accordion-trigger-7"
                  >
                    Location
                  </label>
                  <section className="accordion-animation-wrapper">
                    <div className="accordion-animation">
                      <div className="accordion-transform-wrapper">
                        <div className="accordion-content">
                          {/* <LocationsDone newLocationChange={locationChange} /> */}
                          <LocationsDone handleLocationFilter={locationChange}
                            filterlocations={filterlocations}
                          // locationdata={sefilterlectLocation}
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                <div className="accordion-item">
                  <input
                    id="accordion-trigger-3"
                    className="accordion-trigger-input"
                    type="checkbox"
                    checked={isChecked3}
                    onChange={handleCheckboxChange3}
                  ></input>
                  <label
                    className="accordion-trigger"
                    htmlFor="accordion-trigger-3"
                  >
                    Age Group
                  </label>
                  <section className="accordion-animation-wrapper">
                    <div className="accordion-animation">
                      <div className="accordion-transform-wrapper">
                        <div className="accordion-content">
                          {/* <label>Age Group:</label> */}

                          <select
                            value={selectedAgeGroup || ""}
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setSelectedAgeGroup(selectedValue);
                            }}
                          >
                            {/* ageGroup */}
                            <option value="">Select</option>
                            {ageGroup.map((age) => (
                              <option key={age} value={age}>
                                {age}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                <div className="accordion-item">
                  <input
                    id="accordion-trigger-5"
                    className="accordion-trigger-input"
                    type="checkbox"
                    checked={isChecked5}
                    onChange={handleCheckboxChange5}
                  ></input>
                  <label
                    className="accordion-trigger"
                    htmlFor="accordion-trigger-5"
                  >
                    {selectedCategory === "I want a Babysitter/Nanny"
                      ? "preffered Gender"
                      : "Gender"}
                  </label>
                  <section className="accordion-animation-wrapper">
                    <div className="accordion-animation">
                      <div className="accordion-transform-wrapper">
                        <div className="accordion-content">
                          {/* <label>Gender:</label> */}

                          <select
                            value={selectedGender || ""}
                            onChange={(e) => {
                              const selectedValue = e.target.value;

                              setSelectedGender(selectedValue);
                            }}
                          >
                            {/* ageGroup */}
                            <option value="">Select</option>
                            {genderType.map((gen) => (
                              <option key={gen} value={gen}>
                                {gen}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                <div className="accordion-item">
                  <input
                    id="accordion-trigger-2"
                    className="accordion-trigger-input"
                    type="checkbox"
                    checked={isChecked2}
                    onChange={handleCheckboxChange2}
                  ></input>
                  <label
                    className="accordion-trigger"
                    htmlFor="accordion-trigger-2"
                  >
                    Salary
                  </label>
                  <section className="accordion-animation-wrapper">
                    <div className="accordion-animation">
                      <div className="accordion-transform-wrapper">
                        <div className="accordion-content">
                          <div
                            className={rentStyle.input_box}
                            style={{ marginBottom: "20px" }}
                          >
                            {FreePrice.map((item, index) => (
                              <label
                                key={index}
                                style={{ display: "flex", marginTop: "20px" }}
                              >
                                <input
                                  style={{ width: "40px", marginTop: "1px" }}
                                  type="radio"
                                  value={item}
                                  checked={selectedFree === item}
                                  onChange={handleRentRadioChange}
                                />
                                {item}
                              </label>
                            ))}
                          </div>

                          <Range
                            step={10}
                            min={0}
                            max={100000}
                            values={[priceRange]}
                            onChange={handlePriceChange}
                            renderTrack={({ props, children }) => (
                              <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: "6px",
                                  width: "100%",
                                  backgroundColor: "#ccc",
                                }}
                              >
                                {children}
                              </div>
                            )}
                            renderThumb={({ props }) => (
                              <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: "20px",
                                  width: "20px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                }}
                              />
                            )}
                          />

                          <div style={{ marginTop: "20px" }}>
                            <p>Price: ${priceRange}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div className="accordion-item">
                  <input
                    id="accordion-trigger-8"
                    className="accordion-trigger-input"
                    type="checkbox"
                    checked={isChecked6}
                    onChange={handleCheckboxChange6}
                  ></input>
                  <label
                    className="accordion-trigger"
                    htmlFor="accordion-trigger-8"
                  >
                    Ad Type
                  </label>
                  <section className="accordion-animation-wrapper">
                    <div className="accordion-animation">
                      <div className="accordion-transform-wrapper">
                        <div className="accordion-content">
                          <select
                            value={addOn || ""}
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setAddOn(selectedValue);
                            }}
                          >
                            {/* ageData */}
                            <option value="">Select</option>
                            {addOnData.map((fur) => (
                              <option key={fur} value={fur}>
                                {fur}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                {/* <div className="accordion-item">
                           <input id="accordion-trigger-9" className="accordion-trigger-input" type="checkbox"></input>
                           <label className="accordion-trigger" htmlFor="accordion-trigger-9">Other
                           </label>
                           <section className="accordion-animation-wrapper">
                               <div className="accordion-animation">
                                   <div className="accordion-transform-wrapper">
                                       <div className="accordion-content">
                                           <h2>Accordion content</h2>
                                           <p>This accordion content can be any height. It does not require fixed max-height, or any ways of transitioning height with Javascript.</p>
                                           <p>This should function smoothly in newest Webkit/Chromium browsers.</p>
                                           <p>Here's a Finnish flag:</p>
                                           <p></p>
                                       </div>
                                   </div>
                               </div>
                           </section>
                       </div> */}
              </div>
            </div>
          </div>

          <div className={rentStyle.room_rent_details_lists}>
            <div className={rentStyle.togglle_button_boxes}>
              <div className={rentStyle.pagination_view}>
                {/* <h3>Showing 1 - 40 of 3102 results</h3> */}
                <h3>
                  Showing{" "}
                  {currentPage > 1 ? (currentPage - 1) * perPages + 1 : 1} -{" "}
                  {Math.min(perPages * currentPage, total)} of {total} results
                </h3>
              </div>

              {/* {!check_fav && ( */}
              {!isFavView && (
                <div className={rentStyle.toggle_switch_button}>
                  <h3>New Ads Notification</h3>
                  <input
                    type="checkbox"
                    id="switch"
                    checked={getNotify}
                    onChange={handleToggleChange}
                  />
                  <label htmlFor="switch">Toggle</label>
                  <Tooltip text="Alert me when new ads are added">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#FD7E14"
                      strokeWidth="2.5"
                      strokeLinecap="square"
                      strokeLinejoin="bevel"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                      <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                  </Tooltip>
                </div>
              )}
            </div>
            <div className={rentStyle.right_bar}>
              <div className={rentStyle.job_list_search_bar_icon}>
                <div className={rentStyle.local_text}>
                  {/* <h2>Babysitter & Nannies</h2> */}
                  {/* <h2>{subcategoryName !== ("View All Babysitter & Nannies") ? subcategoryName : categoryName}</h2> */}
                  {/* <h2>{(() => {
                    const urlCategory = searchParams.get("category");
                    const urlSubCategory = searchParams.get("sub_category");

                    if (urlSubCategory) {
                      for (const cat of categoryData) {
                        const sub = cat?.subcategory?.find(s => s._id === urlSubCategory);
                        if (sub) return sub.name;
                      }
                    }

                    if (urlCategory) {
                      const cat = categoryData?.find(c => c._id === urlCategory);
                      if (cat) return cat.name;
                    }

                    return subcategoryName !== "View All Babysitter & Nannies" ? subcategoryName : categoryName;
                  })()}</h2> */}
                  <h2>
  {(() => {
    const urlCategory = searchParams.get("category");
    const urlSubCategory = searchParams.get("sub_category");

    let resolvedName = null;

    if (urlSubCategory) {
      for (const cat of categoryData || []) {
        const sub = cat?.subcategory?.find(s => s._id === urlSubCategory);
        if (sub?.name) { resolvedName = sub.name; break; }
      }
    }

    if (!resolvedName && urlCategory) {
      const cat = categoryData?.find(c => c._id === urlCategory);
      if (cat?.name) resolvedName = cat.name;
    }

    if (!resolvedName) {
      resolvedName = subcategoryName || categoryName;
    }

    if (!resolvedName || resolvedName === "View All Babysitter & Nannies") {
      return "View All Babysitter & Nannies";
    }

    return resolvedName;
  })()}
</h2>
                </div>
                <div className={rentStyle.search_bar_icon_list_bar}>
                  {/* <div className={rentStyle.input_bar}>
                                   <input type="text" placeholder="Find house and rooms for rent" className={rentStyle.form_control} id="search" name="search" />
                               </div> */}
                  {/* <div className={rentStyle.submit_button}>
                                   <button type="submit" className="btn btn-base">
                                       <i className="fa fa-search" aria-hidden="true"></i> <p>Search</p>
                                   </button>
                               </div> */}
                  <div className={rentStyle.arrow_list}>
                    <i
                      onClick={() => {
                        fetchJobsData(currentPage, "Newest");
                        setSortingOption("Newest"); // Set the sorting option
                      }}
                      className={`${rentStyle.active
                        } fa-solid fa-arrow-down-long ${sortingOption === "Newest" ? rentStyle.active : ""
                        }`}
                    ></i>
                    <i
                      onClick={() => {
                        fetchJobsData(currentPage, "Oldest");
                        setSortingOption("Oldest"); // Set the sorting option
                      }}
                      className={`${rentStyle.active
                        } fa-solid fa-arrow-up-long ${sortingOption === "Oldest" ? rentStyle.active : ""
                        }`}
                    ></i>
                  </div>
                </div>
              </div>
              <div className={rentStyle.job_listing_section}>
                {filteredData.length === 0 ? (
                  <div className={rentStyle.no_Data}>
                    <p>No Ad found</p>
                  </div>
                ) : (
                  filteredData.map((babysitter, index) => (
                    <Link
                      style={{
                        color: "#3D89D9",
                        fontWeight: "600",
                        marginLeft: "23px",
                      }}
                      to={`/babySitterDetails/${babysitter._id}`}
                    >
                      <div
                        key={babysitter._id}
                        className={rentStyle.local_jobs_lists}
                      >
                        <div className={rentStyle.job_list_image_wraper}>
                          {/* <img src="/src/assets/Mask group (1).png" alt="" />  */}
                          {/* <img src={FeaturedImage} alt="" /> */}

                          {Array.isArray(babysitter.adsInfo?.image) && babysitter.adsInfo.image.length > 0 ? (
                            <div style={{ width: "200px" }}>
                              <SimpleImageSlider
                                width={200}
                                height={200}
                                images={babysitter.adsInfo.image.map((info) => info.url)}
                                showNavs={babysitter.adsInfo.image.length > 1 ? true : false}
                                showBullets={babysitter.adsInfo.image.length > 1 ? true : false}
                              />
                            </div>
                          ) : (
                            <img src={FeaturedImage} alt="Dummy" />
                          )}


                          <div className={rentStyle.featured_label}>
                            {babysitter.addons_validity.some(
                              // (addon) => addon.name === "Featured" && addon.active_on <= currentDate && addon.expired_on >= currentDate
                              (addon) => addon.name === "Featured" && new Date(addon.expired_on) >= new Date()
                            ) && featureStatus[index] ? (
                              <svg
                                width="91"
                                height="26"
                                viewBox="0 0 91 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  y="0.935547"
                                  width="91"
                                  height="25"
                                  rx="4"
                                  fill="#F07639"
                                />
                                <path
                                  d="M14.7585 17.9355V9.20827H20.5369V10.7296H16.6037V12.8091H20.1534V14.3304H16.6037V17.9355H14.7585ZM21.7781 17.9355V9.20827H27.6587V10.7296H23.6232V12.8091H27.3562V14.3304H23.6232V16.4142H27.6758V17.9355H21.7781ZM30.63 17.9355H28.6527L31.6655 9.20827H34.0433L37.0518 17.9355H35.0746L32.8885 11.2026H32.8203L30.63 17.9355ZM30.5064 14.5051H35.1768V15.9455H30.5064V14.5051ZM36.7035 10.7296V9.20827H43.8711V10.7296H41.1992V17.9355H39.3754V10.7296H36.7035ZM50.4421 9.20827H52.2873V14.8759C52.2873 15.5123 52.1353 16.0691 51.8313 16.5463C51.5302 17.0236 51.1083 17.3958 50.5657 17.6628C50.0231 17.927 49.391 18.0591 48.6694 18.0591C47.945 18.0591 47.3114 17.927 46.7688 17.6628C46.2262 17.3958 45.8043 17.0236 45.5032 16.5463C45.2021 16.0691 45.0515 15.5123 45.0515 14.8759V9.20827H46.8967V14.7182C46.8967 15.0506 46.9691 15.3461 47.114 15.6046C47.2617 15.8631 47.4691 16.0662 47.7362 16.214C48.0032 16.3617 48.3143 16.4355 48.6694 16.4355C49.0273 16.4355 49.3384 16.3617 49.6026 16.214C49.8697 16.0662 50.0756 15.8631 50.2205 15.6046C50.3683 15.3461 50.4421 15.0506 50.4421 14.7182V9.20827ZM53.8054 17.9355V9.20827H57.2486C57.9077 9.20827 58.4702 9.32617 58.9361 9.56197C59.4048 9.79492 59.7614 10.1259 60.0057 10.5549C60.2528 10.981 60.3764 11.4824 60.3764 12.0591C60.3764 12.6387 60.2514 13.1373 60.0014 13.5549C59.7514 13.9696 59.3892 14.2878 58.9148 14.5094C58.4432 14.731 57.8722 14.8418 57.2017 14.8418H54.8963V13.3588H56.9034C57.2557 13.3588 57.5483 13.3105 57.7812 13.214C58.0142 13.1174 58.1875 12.9725 58.3011 12.7793C58.4176 12.5861 58.4759 12.3461 58.4759 12.0591C58.4759 11.7694 58.4176 11.525 58.3011 11.3262C58.1875 11.1273 58.0128 10.9767 57.777 10.8745C57.544 10.7694 57.25 10.7168 56.8949 10.7168H55.6506V17.9355H53.8054ZM58.5185 13.964L60.6875 17.9355H58.6506L56.5284 13.964H58.5185ZM61.6804 17.9355V9.20827H67.5611V10.7296H63.5256V12.8091H67.2585V14.3304H63.5256V16.4142H67.5781V17.9355H61.6804ZM72.1218 17.9355H69.0281V9.20827H72.1474C73.0252 9.20827 73.7809 9.38299 74.4144 9.73242C75.0479 10.079 75.5352 10.5776 75.8761 11.2282C76.2198 11.8787 76.3917 12.6571 76.3917 13.5634C76.3917 14.4725 76.2198 15.2537 75.8761 15.9071C75.5352 16.5605 75.0451 17.062 74.4059 17.4114C73.7695 17.7608 73.0082 17.9355 72.1218 17.9355ZM70.8732 16.3546H72.0451C72.5906 16.3546 73.0494 16.258 73.4215 16.0648C73.7965 15.8688 74.0778 15.5662 74.2653 15.1571C74.4556 14.7452 74.5508 14.214 74.5508 13.5634C74.5508 12.9185 74.4556 12.3915 74.2653 11.9824C74.0778 11.5733 73.7979 11.2722 73.4258 11.079C73.0536 10.8858 72.5948 10.7892 72.0494 10.7892H70.8732V16.3546Z"
                                  fill="#ffffff"
                                />
                              </svg>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className={rentStyle.joblisting_text}>
                            <h3>
                              {babysitter.adsInfo.title
                                ? babysitter.adsInfo.title
                                : "Baby Sitter & Nannies"}
                            </h3>
                            {/* <h3>{babysitter.adsInfo.title ? babysitter.adsInfo.title : ''}</h3> */}

                            <div className={rentStyle.event_text}>
                              {/* <p>Pharetra est nibh semper sed sed vulputate diam. Tempus integer tristique amet viverra turpis semper donec. Tincidunt sit morbi erat eget enim posuere quis pellentesque tellus. </p> */}
                              <p>
                                {babysitter.adsInfo.category.category_name.name}
                              </p>
                            </div>
                            <div className={rentStyle.location_wrap}>
                              <i className="fa-solid fa-location-dot"></i>
                              {/* <p>New York, NY</p> */}
                              <p>
                                {babysitter.adsInfo.location.location_name
                                  ? babysitter.adsInfo.location.location_name
                                  : ""}
                              </p>
                            </div>

                            {/* <Link style={{color:"#3D89D9", fontWeight:'600', marginLeft:"23px"}} to={`/babySitterDetails/${babysitter._id}`} className={rentStyle.view_details_button}>
                                              View Details
                                            </Link> */}

                            <div className={rentStyle.babyAnount}>

                              {/* <p>
                                {babysitter.adsInfo.expected_salary_amount
                                  .is_contact
                                  ? "Please Contact"
                                  : babysitter.adsInfo.expected_salary_amount
                                      .amount !== null
                                  ? `${babysitter.adsInfo.expected_salary_amount.currency} ${babysitter.adsInfo.expected_salary_amount.amount}`
                                  : ""}
                              </p> */}

                              <p>
                                {babysitter.adsInfo.expected_salary_amount.is_contact
                                  ? "Please Contact"
                                  : babysitter.adsInfo.expected_salary_amount.amount !== null &&
                                    babysitter.adsInfo.expected_salary_amount.amount !== 0
                                    ? `${babysitter.adsInfo.expected_salary_amount.currency} ${babysitter.adsInfo.expected_salary_amount.amount}`
                                    : "Please Contact"}
                              </p>


                            </div>

                            <div className={rentStyle.view_details_button}>
                              {/* <p className={rentStyle.countingtext}>$455</p> */}
                              {/* <span>{job.adsInfo.rent.currency ? job.adsInfo.rent.currency : ''} {job.adsInfo.rent.amount ? job.adsInfo.rent.amount : ''}</span> */}
                            </div>
                          </div>
                        </div>
                        <div className={rentStyle.local_job_listing}>
                          <div className={rentStyle.iconPad}>
                            {/* <i className="fa-solid fa-share"></i> */}
                            <div className="page-view-details" onClick={(event) => {
                              shareSocialMediaLink(event, babysitter._id);
                            }}
                            >
                              <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={() => {
                                  buttonHnadler(babysitter._id);
                                }}
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M17.9997 20.4896C17.7312 20.4988 17.4637 20.4539 17.213 20.3575C16.9622 20.2611 16.7335 20.1152 16.5403 19.9285C16.3472 19.7419 16.1936 19.5182 16.0886 19.271C15.9837 19.0237 15.9297 18.7578 15.9297 18.4892C15.9297 18.2206 15.9837 17.9547 16.0886 17.7075C16.1936 17.4602 16.3472 17.2365 16.5403 17.0499C16.7335 16.8632 16.9622 16.7174 17.213 16.621C17.4637 16.5246 17.7312 16.4796 17.9997 16.4888C18.5184 16.5066 19.0099 16.7251 19.3705 17.0983C19.7312 17.4715 19.9328 17.9702 19.9328 18.4892C19.9328 19.0082 19.7312 19.5069 19.3705 19.8801C19.0099 20.2533 18.5184 20.4718 17.9997 20.4896ZM5.9997 14.4896C5.73125 14.4988 5.46369 14.4539 5.21296 14.3575C4.96224 14.2611 4.73349 14.1152 4.54032 13.9285C4.34716 13.7419 4.19355 13.5182 4.08864 13.271C3.98373 13.0237 3.92966 12.7578 3.92966 12.4892C3.92966 12.2206 3.98373 11.9547 4.08864 11.7075C4.19355 11.4602 4.34716 11.2365 4.54032 11.0499C4.73349 10.8632 4.96224 10.7174 5.21296 10.621C5.46369 10.5246 5.73125 10.4796 5.9997 10.4888C6.51839 10.5066 7.0099 10.7251 7.37055 11.0983C7.7312 11.4715 7.93278 11.9702 7.93278 12.4892C7.93278 13.0082 7.7312 13.5069 7.37055 13.8801C7.0099 14.2533 6.51839 14.4718 5.9997 14.4896ZM17.9997 4.49116C18.2682 4.48197 18.5357 4.52691 18.7864 4.6233C19.0372 4.7197 19.2659 4.86557 19.4591 5.05223C19.6522 5.23889 19.8059 5.46252 19.9108 5.7098C20.0157 5.95708 20.0697 6.22294 20.0697 6.49155C20.0697 6.76017 20.0157 7.02603 19.9108 7.27331C19.8059 7.52059 19.6522 7.74422 19.4591 7.93088C19.2659 8.11754 19.0372 8.26341 18.7864 8.35981C18.5357 8.4562 18.2682 8.50114 17.9997 8.49194C17.481 8.47419 16.9895 8.25566 16.6289 7.88245C16.2682 7.50924 16.0666 7.01054 16.0666 6.49155C16.0666 5.97256 16.2682 5.47387 16.6289 5.10066C16.9895 4.72745 17.481 4.50892 17.9997 4.49116ZM17.9997 14.4896C16.7716 14.4896 15.6864 15.0544 14.9528 15.9263L9.94423 13.0365C9.96767 12.856 10.0005 12.6779 10.0005 12.4904C10.0005 12.3779 9.97705 12.2724 9.96767 12.1623L15.0817 9.20913C15.453 9.61313 15.904 9.93582 16.4062 10.1569C16.9084 10.3779 17.451 10.4925 17.9997 10.4935C18.7909 10.4935 19.5643 10.2589 20.2222 9.81942C20.88 9.37991 21.3928 8.75521 21.6957 8.0243C21.9986 7.29339 22.078 6.48909 21.9238 5.71307C21.7696 4.93706 21.3888 4.22419 20.8295 3.66458C20.2702 3.10496 19.5576 2.72374 18.7817 2.56911C18.0057 2.41447 17.2014 2.49336 16.4703 2.79581C15.7392 3.09826 15.1142 3.61069 14.6743 4.26831C14.2344 4.92592 13.9994 5.6992 13.9989 6.49038C13.9989 6.8232 14.0528 7.14195 14.1278 7.45132L9.30439 10.2404C8.91608 9.67032 8.38698 9.21034 7.76845 8.90508C7.14993 8.59982 6.46299 8.45966 5.77431 8.4982C5.08564 8.53673 4.41862 8.75267 3.83802 9.12503C3.25741 9.49739 2.78294 10.0135 2.46066 10.6234C2.13837 11.2332 1.97922 11.916 1.99866 12.6055C2.0181 13.2949 2.21546 13.9677 2.57159 14.5584C2.92771 15.1491 3.43051 15.6377 4.03117 15.9768C4.63183 16.3158 5.30995 16.4938 5.9997 16.4935C7.30048 16.4912 8.44189 15.8607 9.17314 14.8998L14.0763 17.731C13.9194 18.5401 14.0161 19.3778 14.3533 20.1298C14.6906 20.8818 15.2518 21.5112 15.9603 21.9322C16.6688 22.3532 17.49 22.5451 18.3117 22.4816C19.1334 22.4182 19.9154 22.1026 20.5509 21.578C21.1865 21.0533 21.6445 20.3452 21.8623 19.5504C22.0802 18.7555 22.0473 17.9129 21.7681 17.1375C21.4889 16.3621 20.9771 15.6918 20.3026 15.2183C19.6281 14.7448 18.8238 14.4911 17.9997 14.4919V14.4896Z"
                                  fill="#6D737A"
                                />
                              </svg>
                              {isShareOpen && shareID === babysitter._id ? (
                                <SocialMediaLink url={url} />
                              ) : null}
                            </div>

                            <div className={rentStyle.heart_hovered}>
                              {tokenExist && (
                                <div className="heart_hover">
                                  {!favStatus[index] ? (
                                    <div onClick={(event) => { event.preventDefault(); handleHeartIconClick(index, babysitter._id); }}>
                                      <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"

                                      >
                                        <g clipPath="url(#clip0_181_9810)">
                                          <path
                                            d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M15.5591 10.9359L15.9594 11.471L16.3598 10.9359C17.0879 9.96261 18.2546 9.33008 19.5558 9.33008C21.764 9.33008 23.5593 11.1288 23.5593 13.358C23.5593 14.2675 23.4143 15.1066 23.1624 15.8851L23.1614 15.8884C22.5573 17.8001 21.3181 19.3442 19.9761 20.4976C18.6318 21.6529 17.2131 22.3913 16.3006 22.7018L16.3006 22.7018L16.2952 22.7037C16.2277 22.7275 16.1059 22.7481 15.9594 22.7481C15.8129 22.7481 15.6912 22.7275 15.6236 22.7037L15.6236 22.7036L15.6183 22.7018C14.7058 22.3913 13.287 21.6529 11.9427 20.4976C10.6006 19.3442 9.36144 17.8001 8.75734 15.8884L8.75735 15.8884L8.7563 15.8851C8.50442 15.1066 8.35938 14.2675 8.35938 13.358C8.35938 11.1289 10.1547 9.33008 12.363 9.33008C13.6642 9.33008 14.8309 9.96261 15.5591 10.9359Z"
                                            stroke="black"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_181_9810">
                                            <rect
                                              width="32"
                                              height="32"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                  ) : (
                                    <div onClick={(event) => { event.preventDefault(); handleHeartIconClick(index, babysitter._id); }}>
                                      <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0_315_9939)">
                                          <path
                                            d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M19.5558 8.83008C18.0897 8.83008 16.7775 9.54288 15.9594 10.6364C15.1413 9.54288 13.8291 8.83008 12.363 8.83008C9.87627 8.83008 7.85938 10.8551 7.85938 13.358C7.85938 14.3219 8.01327 15.2129 8.28057 16.0391C9.56037 20.0891 13.5051 22.511 15.4572 23.1752C15.7326 23.2724 16.1862 23.2724 16.4616 23.1752C18.4137 22.511 22.3583 20.0891 23.6381 16.0391C23.9054 15.2129 24.0593 14.3219 24.0593 13.358C24.0593 10.8551 22.0425 8.83008 19.5558 8.83008Z"
                                            fill="#FF7700"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_315_9939">
                                            <rect
                                              width="32"
                                              height="32"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            <div className="view-btn">
                              <div className="heart_count">
                                <svg
                                  width="20"
                                  height="18"
                                  viewBox="0 0 25 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M23.3064 7.90968C23.8506 8.62284 23.8506 9.58561 23.3064 10.2976C21.5921 12.5395 17.4793 17.1555 12.6775 17.1555C7.87577 17.1555 3.76293 12.5395 2.04867 10.2976C1.78388 9.95615 1.64014 9.53606 1.64014 9.10365C1.64014 8.67125 1.78388 8.25116 2.04867 7.90968C3.76293 5.66782 7.87577 1.05182 12.6775 1.05182C17.4793 1.05182 21.5921 5.66782 23.3064 7.90968V7.90968Z"
                                    stroke="#C9C9C9"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M12.6776 12.5544C14.58 12.5544 16.1222 11.0094 16.1222 9.10362C16.1222 7.1978 14.58 5.65283 12.6776 5.65283C10.7752 5.65283 9.23297 7.1978 9.23297 9.10362C9.23297 11.0094 10.7752 12.5544 12.6776 12.5544Z"
                                    stroke="#C9C9C9"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                <span style={{ color: '#6D737A', fontSize: '14px', marginLeft: '-6px' }}>{babysitter.viewCount || 0}</span>
                              </div>
                            </div>
                          </div>
                          {/* <button className={rentStyle.urgent_btn}>urgent</button> */}
                          {babysitter.addons_validity &&
                            babysitter.addons_validity.length > 0 &&
                            (babysitter.addons_validity.some(
                              (addon) => addon.name === "Urgent" && addon.active_on <= currentDate && addon.expired_on >= currentDate
                            ) ? (
                              <button className={rentStyle.urgent_btn}>
                                urgent
                              </button>
                            ) : null)}

                          {/* <h6>Listed on: <span>2 days ago</span> </h6> */}
                          <h6>
                            Listed on:{" "}
                            <span>
                              {getTimeSinceCreation(babysitter.active_on_virtual, babysitter.location_timezone)}
                            </span>
                          </h6>
                        </div>
                      </div>
                    </Link>
                  ))
                )}
              </div>

              <div className={rentStyle.Pagination}>
                {currentPage > 1 && (
                  <button
                    className={rentStyle.prevButton}
                    onClick={handlePrevPage}
                  >
                    Previous
                  </button>
                )}
                <span>
                  {currentPage} of {totalPages}
                </span>
                {currentPage < totalPages && (
                  <button
                    className={rentStyle.nextButton}
                    onClick={handleNextPage}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
            <div className={rentStyle.banner_image_wrap}>
              {/* <img src="/images/image 106 (1).png" alt="" /> */}
              {/* <img src={addFreeImage} alt="" /> */}
              <Banner bottombanner={true} />
            </div>
          </div>

          <div className={rentStyle.side_banner}>
            {/* <img src="src/assets/addfreeimg.png" alt="" /> */}
            {/* <img src={sidebanner} alt="" /> */}
            <Banner sidebanner={true} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BabySitter_view;
